import { useMutation } from '@tanstack/react-query';

import { createCrossSeller } from '../services';

export function useCreateCrossSeller() {
  return useMutation({
    mutationFn: createCrossSeller,
  });
}
